import getCssVar from 'src/utils/getCssVar'
import COLORS from 'src/data/colors'

const getCssVarWithFallback = (name, fallback) => getCssVar(name).trim() || fallback

// A custom web font (e.g. Source Sans Pro) can't load inside Blackbaud's
// cross-origin iframe, so — like the Stripe card form (see stripeAppearance.js)
// — we hand it a web-safe system stack for a consistent card-field look.
const FONT_FAMILY =
  'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", ' +
  '"Noto Sans", "Liberation Sans", Arial, sans-serif'

// Style Blackbaud Checkout's inline fields to match the widget's own inputs.
// The brand color is the one partner-themed value, read live from the same
// --bs-primary the widget renders with; the rest mirror our Bootstrap tokens.
// These keys are passed straight into BlackbaudCheckout({...}) — Blackbaud
// forwards them to the inline iframe, which applies them to its fields.
const blackbaudAppearance = ({ showInputLabels } = {}) => {
  const primaryColor = getCssVarWithFallback('--bs-primary', COLORS.primary)
  const fontColor = '#212529'  // Bootstrap $body-color
  const borderRadius = '8px'   // Bootstrap $border-radius (.5rem); Blackbaud requires px

  return {
    primaryColor,
    fontColor,
    fontFamily: FONT_FAMILY,
    inputStyles: {
      borderRadius,
      // Our fields show labels above when enabled, otherwise placeholder-only;
      // 'floating' is Blackbaud's closest match to the placeholder style.
      labelStyle: showInputLabels ? 'above' : 'floating',
      fontFamily: FONT_FAMILY,
    },
    buttonTheme: {
      borderRadius,
      selected: { backgroundColor: primaryColor, fontColor: '#ffffff', fontFamily: FONT_FAMILY },
      unselected: { fontFamily: FONT_FAMILY },
    },
  }
}

export default blackbaudAppearance
